import React, { Component } from 'react';
import { flowRight as compose } from 'lodash';
import { injectIntl } from 'react-intl';
import LocationList from '../../../components/SiteAdmin/ManageLocationList/LocationList';
import Loader from '../../../components/Common/Loader/Loader';
import getLocationList from './getLocationList.graphql';
import messages from '../../../locale/messages';
import { withQuery } from '../../../hoc/withGraphql';

export class ManageLocation extends Component {

    static defaultProps = {
        booking: {
            loading: true
        }
    }

    render() {
        const { formatMessage } = this.props.intl;
        const { locationList, locationList: { loading } } = this.props;

        return (
            <Loader type={"page"} show={loading}>
                <h1 className='siteAdminPrimaryHeading'>{formatMessage(messages.location)}</h1>
                {!loading && <LocationList locationList={locationList} loading={loading} />}
            </Loader>
        );
    }
}

export default compose(
    injectIntl,
    withQuery(getLocationList, {
        name: 'locationList',
        options: {
            variables: {
                currentPage: 1,
                searchList: ''
            },
            fetchPolicy: 'network-only',
            ssr: false
        }
    })
)(ManageLocation);
